import React, { createContext, ReactNode, useCallback, useState } from 'react';

import { CorporateAccountDetailsData } from '../accountsServices/CorporateAccountsService';

type CorporateAccountContextType = {
  groupName: CorporateAccountDetailsData['companyName'];
  businessSector: CorporateAccountDetailsData['businessSector'];
  saveGroupName: (
    groupName: CorporateAccountDetailsData['companyName']
  ) => void;
  saveBusinessSector: (
    businessSector: CorporateAccountDetailsData['businessSector']
  ) => void;
};

const initialValue: CorporateAccountContextType = {
  groupName: '',
  businessSector: null,
  saveGroupName: () => null,
  saveBusinessSector: () => null,
};

export const CorporateAccountContext =
  createContext<CorporateAccountContextType>(initialValue);

const CorporateAccountContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [groupName, setGroupName] = useState(initialValue.groupName);
  const [businessSector, setBusinessSector] = useState(
    initialValue.businessSector
  );

  const saveGroupName = useCallback(
    (groupName: CorporateAccountDetailsData['companyName']) => {
      setGroupName(groupName);
    },
    []
  );

  const saveBusinessSector = useCallback(
    (businessSector: CorporateAccountDetailsData['businessSector']) => {
      setBusinessSector(businessSector);
    },
    []
  );

  return (
    <CorporateAccountContext.Provider
      value={{
        groupName,
        businessSector,
        saveGroupName,
        saveBusinessSector,
      }}
    >
      {children}
    </CorporateAccountContext.Provider>
  );
};

export default CorporateAccountContextProvider;
